import { useEffect, useState } from "react";
import { req } from "./ServerUtils";

export function TCALinks() {
    const [links, setLinks] = useState([])  
    useEffect(() => {
        req('get-tca4-links', 'GET', null, true, 'https://api.ideakart.in/')
        .then(data => {
            setLinks(data)
            console.log(data)
            // if link has ?utm_source=..., strip it
            setLinks(data.map(link => {
                if (link.link.includes('?utm_source=')) {
                    return {
                        ...link,
                        link: link.link.split('?')[0]
                    }
                }
                return link
            }))
        })
    }, [])
    return (
        <div>
            <ul>
                {links.map(link => (
                    <a style={{
                        display: 'block',
                        marginBottom: '20px',
                        textDecoration: 'none',
                        fontSize: '16px',
                    }} href={link.link} target="_blank" rel="noopener noreferrer">{link.link}</a>
                ))}
            </ul>
        </div>
    )   
}